import { adminHttpClient } from '../../commons/adminHttpClient'

const getProspectAnalysisLink = (code: string): Promise<string> => {
  var encodedCode = encodeURIComponent(code)

  return adminHttpClient.get(`/IchraDecisionTool/ProspectApplication/ProspectAnalysis?code=${encodedCode}`)
}

export default getProspectAnalysisLink
